<ng-container>
    <cmps-dialog class="commitment-dialog-box">
        <cmps-dialog-header [closeTooltip]="_i18n.__CLOSE | translate">
            {{ _i18n.__COMMITMENT_DETAILS | translate }}
        </cmps-dialog-header>
        <cmps-dialog-body>
            <table
                class="cmps-coaching-wp-table"
                *ngIf="columns | async as cols"
            >
                <thead>
                    <tr>
                        <ng-container *ngFor="let th of cols; let i = index">
                            <th
                                (click)="th.icon && toggle(th.icon[0], cols)"
                                [ngStyle]="th.styles"
                                class="commit-floa-header"
                                [ngClass]="th.class"
                                *ngIf="th.active === true"
                            >
                                <div class="floa-header">
                                    <div
                                        *ngIf="th.left"
                                        [ngClass]="th.left.class"
                                        [innerHTML]="th.left.content"
                                    ></div>

                                    <div
                                        class="commit-detail-header-item"
                                        [ngClass]="th.classes"
                                    >
                                        <div
                                            class="header-content"
                                            [ngClass]="th.headerContentClass"
                                            [innerHTML]="th.header"
                                        ></div>
                                        <ng-container *ngIf="i == 8">
                                            <div
                                                [cmpsTooltipTrigger]="
                                                    _i18n.__THE_VALUE_AT_WHICH
                                                        | translate
                                                "
                                            >
                                                <cmps-icon
                                                    svgIcon="information-outline"
                                                ></cmps-icon>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="i == 5">
                                            <div
                                                [cmpsTooltipTrigger]="
                                                    _i18n.__THE_VALUE_USER_ACHIEVED
                                                        | translate
                                                "
                                            >
                                                <cmps-icon
                                                    svgIcon="information-outline"
                                                ></cmps-icon>
                                            </div>
                                        </ng-container>
                                        <ng-container
                                            *ngFor="let icon of th.icon"
                                        >
                                            <div
                                                class="commit-detail-header-icon-container"
                                            >
                                                <cmps-icon
                                                    [svgIcon]="
                                                        icon.class[icon.counter]
                                                    "
                                                    *ngIf="
                                                        icon &&
                                                        icon.state !== undefined
                                                    "
                                                ></cmps-icon>
                                            </div>
                                        </ng-container>
                                    </div>

                                    <div
                                        *ngIf="th.right"
                                        [ngClass]="th.right.class"
                                        [innerHTML]="th.right.content"
                                    ></div>
                                </div>
                            </th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="10"></td>
                    </tr>
                    <ng-container *ngFor="let data of rawData">
                        <tr>
                            <td>{{ data.username }}</td>
                            <td>
                                {{ data.startDate | cmpsDate: 'MMM dd, y' }}
                            </td>
                            <td>{{ data.metricName }}</td>
                            <td>
                                <span
                                    class="behaviour-name"
                                    *ngIf="
                                        data.behaviourNameTooltip.length <= 100
                                    "
                                >
                                    {{ data.behaviourName }};</span
                                >
                                <span
                                    class="behaviour-name"
                                    *ngIf="
                                        data.behaviourNameTooltip.length > 100
                                    "
                                    [cmpsTooltipTrigger]="
                                        data.behaviourNameTooltip
                                    "
                                    >{{ data.behaviourName }}
                                </span>
                                <br />
                                <span
                                    class="sub-behaviour-name"
                                    *ngIf="
                                        data.subBehaviourNameTooltip.length <=
                                        100
                                    "
                                >
                                    {{ data.subBehaviourName }}</span
                                >
                                <span
                                    class="sub-behaviour-name"
                                    *ngIf="
                                        data.subBehaviourNameTooltip.length >
                                        100
                                    "
                                    [cmpsTooltipTrigger]="
                                        data.subBehaviourNameTooltip
                                    "
                                >
                                    {{ data.subBehaviourName }}
                                </span>
                            </td>
                            <td>
                                {{
                                    data.startActual != null
                                        ? (data.startActual
                                          | cmpsNumber: '1.2-2')
                                        : '-'
                                }}
                            </td>
                            <td>
                                {{
                                    data.assessedActual != null
                                        ? (data.assessedActual
                                          | cmpsNumber: '1.2-2')
                                        : '-'
                                }}
                            </td>
                            <td>
                                {{
                                    data.percentageImprovement != null
                                        ? (data.percentageImprovement / 100
                                          | cmpsPercent: '1.1-1')
                                        : '-'
                                }}
                            </td>
                            <td>
                                <div *ngIf="data.winning">
                                    <ng-container
                                        *ngTemplateOutlet="winning"
                                    ></ng-container>
                                </div>
                                <div *ngIf="data.losing">
                                    <ng-container
                                        *ngTemplateOutlet="losing"
                                    ></ng-container>
                                </div>
                                <div *ngIf="data.neutral">
                                    <ng-container
                                        *ngTemplateOutlet="neutral"
                                    ></ng-container>
                                </div>
                            </td>
                            <td class="text-center">
                                {{
                                    data.winsAt != null
                                        ? (data.winsAt | cmpsNumber: '1.2-2')
                                        : ' '
                                }}
                            </td>
                            <td>
                                <span
                                    class="view-commitment-link"
                                    (click)="_onViewCommitmentClick(data)"
                                >
                                    <span class="view-commitment-icon">
                                        <cmps-icon
                                            svgIcon="folder-account-outline"
                                        ></cmps-icon>
                                    </span>
                                    <span class="view-commitment-text">{{
                                        _i18n.__VIEW_COMMITMENT | translate
                                    }}</span>
                                </span>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="rawData === 0">
                        <tr class="text-center">
                            <td>{{ _i18n.__NO_DATA_FOUND | translate }}</td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </cmps-dialog-body>
    </cmps-dialog>
</ng-container>

<ng-template #neutral>
    <div class="commitment-mark-status mark-neutral">
        <div class="commitment-mark-status-left"></div>
        <div class="commitment-mark-status-text">Neutral</div>
    </div>
</ng-template>
<ng-template #losing>
    <div class="commitment-mark-status mark-losing">
        <div class="commitment-mark-status-left"></div>
        <div class="commitment-mark-status-text">Losing</div>
    </div>
</ng-template>
<ng-template #winning>
    <div class="commitment-mark-status mark-winning">
        <div class="commitment-mark-status-left"></div>
        <div class="commitment-mark-status-text">Winning</div>
    </div>
</ng-template>
